import { render, staticRenderFns } from "./InformeList.vue?vue&type=template&id=311dc889&scoped=true"
import script from "./InformeList.vue?vue&type=script&lang=js"
export * from "./InformeList.vue?vue&type=script&lang=js"
import style0 from "./InformeList.vue?vue&type=style&index=0&id=311dc889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311dc889",
  null
  
)

export default component.exports